import React, { useState } from 'react';
import styles from './Panel.module.css';

const Panel = ({
    title,
    children,
    footer,
    className = '',
    collapsible = false,
    defaultCollapsed = false,
    collapsed: controlledCollapsed,
    onToggle,
    ...restProps
}) => {
    const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);
    const isCollapsed = controlledCollapsed !== undefined ? controlledCollapsed : internalCollapsed;

    const handleToggle = () => {
        if (onToggle) {
            onToggle(!isCollapsed);
        } else if (collapsible) {
            setInternalCollapsed(!isCollapsed);
        }
    };

    return (
        <div className={`${styles.panel} ${className}`} {...restProps}>
            {title && (
                <div className={styles.panelHeader}>
                    <h3 className={styles.panelTitle}>{title}</h3>
                    {collapsible && (
                        <button
                            className={styles.toggleButton}
                            onClick={handleToggle}
                            aria-label={isCollapsed ? 'Развернуть панель' : 'Свернуть панель'}
                            aria-expanded={!isCollapsed}
                            type="button"
                        >
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                style={{ transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(90deg)', transition: 'transform 0.2s ease' }}
                            >
                                <path
                                    d="M6 9L2 5L6 1"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    )}
                </div>
            )}
            {!isCollapsed && (
                <>
                    <div className={styles.panelContent}>
                        {children}
                    </div>
                    {footer && <div className={styles.panelFooter}>{footer}</div>}
                </>
            )}
        </div>
    );
};

export default Panel;